import OneSignalOriginal from 'react-onesignal';

const OneSignal = {
  async init({ appId }) {
    await OneSignalOriginal.init({
      appId,
      allowLocalhostAsSecureOrigin: true,
    });
    await OneSignalOriginal.showSlidedownPrompt().then(() => {
      // do other stuff
    });
  },
  setExternalUserId: OneSignalOriginal.setExternalUserId,
  setEmail: OneSignalOriginal.setEmail,
  sendTags: OneSignalOriginal.sendTags,
  addTrigger: (name: string, value: string) => {
    return null
  },
  addTriggers: (triggers: any) => {
    return null
  },
}
export {
  OneSignal
}
